
class ExclusiveCheckboxesController {

    constructor() {
        $('.exclusive-checkboxes').each(function(i, node){
            new ExclusiveCheckboxesSectionController($(node));
        });
    }
}

class ExclusiveCheckboxesSectionController {

    constructor(node) {
        this.node = node;
        this.oppositeNode = $(this.node.attr('data-exclusive-with'));
        this.node.find('.form-check-input').change(this.update.bind(this));
        this.update();
    }

    update() {
        let thisObj = this;
        this.node.find('.form-check-input').each(function(i, check){
            check = $(check);
            let value = check.val();
            let oppositeCheck = thisObj.oppositeNode.find('.form-check-input[value="'+value+'"]');
            oppositeCheck.enableIf(!check.isChecked());
            oppositeCheck.parent().addClassIf('disabled-checkbox', check.isChecked());
        });
    }
}
